import Divider from './Divider';

export default Divider;
export { Divider };
export type { DividerProps } from './interface';
